module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "size": "confirm_size",
      "title": "End Discussion"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col h-full py-4 px-6"
  }, [_c('div', {
    staticClass: "flex flex-grow h-full mb-5"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2 text-gray-700"
  }, [_c('span', [_vm._v("\n          Stopping the discussion "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("will prevent discussion statistics")]), _vm._v(" from\n          changing, and students "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("will not be able")]), _vm._v(" to tap in.\n        ")]), _vm._v(" "), _c('span', [_vm._v("You "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("will be able to restart")]), _vm._v(" the discussion whenever you want.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between space-x-4"
  }, [_c('button', {
    staticClass: "w-full bg-gray-100 border border-solid border-gray-200 rounded-md py-2 px-4 text-gray-700",
    on: {
      "click": function($event) {
        _vm.show_confirm_end_discussion = false
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "flex justify-center items-center space-x-2 w-full bg-red-500 rounded-md border border-solid border-red-500 py-2 px-4 text-white",
    on: {
      "click": function($event) {
        return _vm.handleEndDiscussion()
      }
    }
  }, [_c('span', [_vm._v("Stop Discussion")]), _vm._v(" "), (_vm.isEnding) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-33bcbe30!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/MDEndDiscussion.vue
// module id = 1859
// module chunks = 61